import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "address-autocomplete-combobox__icons" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ComboboxRoot"], {
    modelValue: $setup.details,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.details) = $event)),
    "ignore-filter": true,
    open: $setup.isOpen,
    disabled: $props.disabled
  }, {
    default: _withCtx(() => [
      _createVNode($setup["ComboboxAnchor"], { class: "address-autocomplete-combobox__anchor" }, {
        default: _withCtx(() => [
          ($setup.details === undefined)
            ? (_openBlock(), _createBlock($setup["ComboboxInput"], {
                key: 0,
                id: "address-combobox",
                modelValue: $setup.searchTerm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.searchTerm) = $event)),
                "aria-invalid": $props.isFormSubmitted && !$props.disabled,
                autocomplete: "off",
                class: "order-form__input-text address-autocomplete-combobox__input",
                "display-value": $setup.getInputDisplayValue,
                placeholder: $props.placeholder
              }, null, 8 /* PROPS */, ["modelValue", "aria-invalid", "placeholder"]))
            : _createCommentVNode("v-if", true),
          ($setup.details !== undefined)
            ? (_openBlock(), _createElementBlock("input", {
                key: 1,
                ref: "displayInput",
                value: $setup.details.mail_lines.join(', '),
                class: "order-form__input-text address-autocomplete-combobox__input",
                readonly: ""
              }, null, 8 /* PROPS */, _hoisted_1))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_2, [
            ($setup.details !== undefined)
              ? (_openBlock(), _createBlock($setup["ResetButton"], {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.details = undefined))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($props.resetLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($setup.status === 'loading')
              ? (_openBlock(), _createBlock($setup["motion"].span, {
                  key: 1,
                  class: "key-spinner",
                  animate: { rotate: 360 },
                  transition: { duration: 1, ease: 'linear', repeat: Infinity }
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["LoadingIcon"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["ComboboxPortal"], null, {
        default: _withCtx(() => [
          _createVNode($setup["ComboboxContent"], {
            position: 'popper',
            "position-strategy": 'absolute',
            "collapse-padding": { top: '20px', bottom: '20px' },
            class: "address-autocomplete-combobox-colors address-autocomplete-combobox__content"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["ComboboxViewport"], null, {
                default: _withCtx(() => [
                  _createVNode($setup["ComboboxEmpty"], { class: "address-autocomplete-combobox__option" }, {
                    default: _withCtx(() => [
                      ($setup.status === 'done')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.noResultsMessage), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($setup.status === 'error')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($props.searchErrorMessage), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.suggestions, (suggestion) => {
                    return (_openBlock(), _createBlock($setup["ComboboxItem"], {
                      key: suggestion.data.value,
                      value: suggestion.data,
                      class: "address-autocomplete-combobox__option",
                      onSelect: _withModifiers(() => $setup.onSelect(suggestion), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", null, _toDisplayString(suggestion.data.label), 1 /* TEXT */),
                          _createElementVNode("small", null, _toDisplayString(suggestion.data.description), 1 /* TEXT */)
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onSelect"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "open", "disabled"]))
}